module.exports = __webpack_public_path__ + "21158d0f8057a1b6de3ee9f6f28aa3b5.svg";